import { render, staticRenderFns } from "./CorrectListDetails.vue?vue&type=template&id=2f24145d&scoped=true&"
import script from "./CorrectListDetails.vue?vue&type=script&lang=ts&"
export * from "./CorrectListDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectListDetails.vue?vue&type=style&index=0&id=2f24145d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24145d",
  null
  
)

export default component.exports